'use client'

import { Box, Typography } from '@mui/material'
import { useTranslations } from 'use-intl'

import {
    baggageIcon,
    cancellation,
    dateChange,
    seatSelection,
    meal,
    cabinBaggageIcon
} from './icons'

const BENEFIT_ICONS: Record<string, JSX.Element | null> = {
    checkInBagAdult: baggageIcon,
    cabinBagAdult: cabinBaggageIcon,
    refundOnCancellation: cancellation,
    dateChangeFees: dateChange,
    seat: seatSelection,
    meal: meal
}

export default function FareCategorySidebar({
    isExclusiveBenefitsAvailable,
    rowHeights,
    registerRef
}: {
    isExclusiveBenefitsAvailable: boolean
    rowHeights: number[]
    height: number | null
    benefitKeys: string[]
    registerRef: (colIndex: number, rowIndex: number) => (el: HTMLDivElement | null) => void
}) {
    const t = useTranslations('common')
    const tFareFamily = useTranslations('fareFamily')

    if (isExclusiveBenefitsAvailable) {
        BENEFIT_ICONS['exclusiveBenefits'] = null
    }

    return (
        <Box
            bgcolor={'#F9FAFB'}
            sx={{
                minWidth: 220,
                display: 'grid',
                mt: 2,
                pl: { md: 1, lg: 2 },
                alignSelf: 'flex-start',
                zIndex: 2,
                borderRadius: '10px',
            }}
        >
            <Box display="flex" alignItems="center" sx={{ mb: 6, mt: '1rem', ml: 1 }}>
                <Typography variant="h6">{tFareFamily('Plans')}</Typography>
            </Box>

            {Object.entries(BENEFIT_ICONS).map(([key,value], rowIndex) => (
                <Box
                    key={key}
                    ref={registerRef(0, rowIndex)}
                    display="flex"
                    alignItems="center"
                    sx={{
                        minHeight: rowHeights[rowIndex] ?? 'auto',
                        padding: '12px 8px',
                        boxSizing: 'border-box'
                    }}
                >
                    {value}
                    <Typography variant="body2" sx={{ ml: 1, fontWeight: '500' }}>
                        {t(key)}
                    </Typography>
                </Box>
            ))}
        </Box>
    )
}